interface BannerApiData {
    displayCount?: number;
    dataIdentifier: string;
    includeCustomHTML?: boolean;
}

export const FetchBannerApiData = async ({
    displayCount = 1,
    dataIdentifier,
    includeCustomHTML = false,
}: BannerApiData) => {
    const params = new URLSearchParams({
        displayCount: displayCount.toString(),
        dataIdentifier: dataIdentifier,
        includeCustomHTML: includeCustomHTML.toString()
    });

    const url = `/api/v1/banners/filter?${params.toString()}`;

    const response = await fetch(url, {
        method: "GET"
    });
    
    const data = await response.json();
    return data;
};
